import React, { useEffect, useState } from "react";
import "./PopularCategories.scss";
import { Button, Form, Modal, Spin, message } from "antd";
import { FormMultiSelect } from "../FormInputs/FormSelect";
import { deleteApi, getApi, postApi } from "../../utils/apiServices";
import { IMAGE_BASE_PATH } from "../../utils/constant";
import { CloseOutlined } from "@ant-design/icons";
import { categoryOptions, spinContent } from "../../services/customData";
import {
  ADD_POPULAR_CATEGORY,
  DELETE_POPULAR_CATEGORY,
  GET_CATEGORIES_LIST,
  GET_POPULAR_CATEGORIES,
} from "../../utils/apiPath";
import { FormRadioGroup } from "../FormInputs/FormRadio";
import ToastHelper from "../../services/ToastHelper";

const PopularCategories = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [popularCategory, setPopularCategory] = useState([]);
  const [categoryList1, setCategoryList1] = useState([]);
  const [categoryList2, setCategoryList2] = useState([]);
  const [categoryList3, setCategoryList3] = useState([]);
  const [categoryFilterList, setCategoryFilterList] = useState([]);
  const [categoryOption, setCategoryOption] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      let selectedIds = [];

      if (categoryOption === 1) {
        selectedIds = values.categoryLayer1 || [];
      } else if (categoryOption === 2) {
        selectedIds = values.categoryLayer2 || [];
      } else if (categoryOption === 3) {
        selectedIds = values.categoryLayer3 || [];
      }

      const payload = { categoryIds: selectedIds };
      const res = await postApi(`${ADD_POPULAR_CATEGORY}`, payload);
      setLoading(false);
      message.success("Category topic items added successfully");
      form.resetFields();
      setIsModalOpen(false);
      getPopularCategoriesList();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    getPopularCategoriesList();
  }, []);

  const getPopularCategoriesList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_POPULAR_CATEGORIES}`);
      setPopularCategory(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    if (categoryOption) {
      const topicIds = popularCategory?.map((item) => item?.id);
      if (categoryOption === 1) {
        setCategoryFilterList(
          categoryList1?.filter((item) => !topicIds.includes(item.value))
        );
      } else if (categoryOption === 2) {
        setCategoryFilterList(
          categoryList2?.filter((item) => !topicIds.includes(item.value))
        );
      } else {
        setCategoryFilterList(
          categoryList3?.filter((item) => !topicIds.includes(item.value))
        );
      }
    }
  }, [
    popularCategory,
    categoryOption,
    categoryList1,
    categoryList2,
    categoryList3,
  ]);

  const fetchCategories = async (parentId = 0) => {
    const payload = {
      pageIndex: 0,
      pageSize: 100,
      searchString: "",
      parentCategoryId: parentId,
    };
    try {
      const res = await postApi(`${GET_CATEGORIES_LIST}`, payload);
      return res?.data || [];
    } catch (error) {
      console.error("Error fetching categories", error);
      return [];
    }
  };

  useEffect(() => {
    (async () => {
      const options = await fetchCategories();
      setCategoryList1(
        options?.map((item) => ({ label: item.title, value: item.id }))
      );
    })();
  }, []);

  const handleLayer1Change = async (value) => {
    form.setFieldsValue({ categoryLayer2Id: null, categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList2(
      options?.map((item) => ({ label: item.title, value: item.id }))
    );
    setCategoryList3([]);
  };

  const handleLayer2Change = async (value) => {
    form.setFieldsValue({ categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList3(
      options?.map((item) => ({ label: item.title, value: item.id }))
    );
  };

  const handleValuesChange = (changedValues, allValues) => {
    if ("categoryOption" in changedValues) {
      setCategoryOption(changedValues.categoryOption);
      form.setFieldsValue({
        categoryLayer1: null,
        categoryLayer2: null,
        categoryLayer3: null,
      });
    }
  };

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen(false);
  };

  const handleDeleteTopicItem = async () => {
    try {
      const res = await deleteApi(
        `${DELETE_POPULAR_CATEGORY}?PopularCategoryId=${deleteItem?.popularCategoryId}`
      );

      if (res?.statusCode === 200) {
        ToastHelper.success("Popular category deleted successfully");
        handleClose();
        getPopularCategoriesList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="p-categories">
      <div className="p-categories_container">
        <div className="p-categories_header">
          <div className="p-categories_header_left">
            <h2>Popular Categories</h2>
          </div>
          <div className="p-categories_header_right">
            <Button type="primary" onClick={showModal}>
              Add
            </Button>
          </div>
        </div>
        <div className="p-categories_sections">
          <div className="p-categories_cards">
            {popularCategory?.length > 0 &&
              popularCategory?.map((topic, index) => (
                <div key={index} className="p-categories_card">
                  <div className="p-categories_card_image">
                    <img
                      src={`${IMAGE_BASE_PATH}${topic?.media?.url}`}
                      alt=""
                    />
                    <div
                      className="p-categories_card_close"
                      onClick={() => handleDeleteModal(topic)}
                    >
                      <CloseOutlined />
                    </div>
                  </div>
                  <div className="p-categories_card_content">
                    <h3>{topic?.title}</h3>
                  </div>
                </div>
              ))}
          </div>
          {loading ? (
            <div className="p-categories_loading">
              <Spin tip="Loading">{spinContent}</Spin>
            </div>
          ) : (
            popularCategory?.length === 0 && (
              <h5>No popular categories available</h5>
            )
          )}
        </div>
      </div>
      <Modal
        title="Add"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
      >
        <div className="p-categories_modal">
          <Form form={form} layout="vertical">
            <Form
              form={form}
              layout="vertical"
              onValuesChange={handleValuesChange}
            >
              <FormRadioGroup
                label="Select the category option"
                name="categoryOption"
                rules={[
                  {
                    required: true,
                    message: "Please select an category option",
                  },
                ]}
                options={categoryOptions}
              />
              {categoryOption && (
                <FormMultiSelect
                  label="Select category layer1"
                  name="categoryLayer1"
                  placeholder="Select category layer1"
                  rules={[{ required: true }]}
                  options={
                    categoryOption === 1 ? categoryFilterList : categoryList1
                  }
                  mode={categoryOption === 1 && "multiple"}
                  onChange={categoryOption === 1 ? null : handleLayer1Change}
                />
              )}
              {(categoryOption === 2 || categoryOption === 3) && (
                <FormMultiSelect
                  label="Select category layer2"
                  name="categoryLayer2"
                  placeholder="Select category layer2"
                  rules={[{ required: true }]}
                  options={
                    categoryOption === 2 ? categoryFilterList : categoryList2
                  }
                  mode={categoryOption === 2 && "multiple"}
                  onChange={categoryOption !== 3 ? null : handleLayer2Change}
                />
              )}
              {categoryOption === 3 && (
                <FormMultiSelect
                  label="Select category layer3"
                  name="categoryLayer3"
                  placeholder="Select category layer3"
                  rules={[{ required: true }]}
                  options={
                    categoryOption === 3 ? categoryFilterList : categoryList3
                  }
                  mode={categoryOption === 3 && "multiple"}
                />
              )}
            </Form>
          </Form>
        </div>
      </Modal>
      <Modal
        title="Confirm"
        open={open}
        onOk={handleDeleteTopicItem}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default PopularCategories;
